(() => {
  class CustomProductZoom {
    constructor(root) {
      this.root = root;
      this.group = root.dataset.customZoomGroup;
      this.gallery = root.closest('media-gallery') || document;

      this.image = root.querySelector('[data-zoom-image]');
      this.prevBtn = root.querySelector('[data-zoom-prev]');
      this.nextBtn = root.querySelector('[data-zoom-next]');
      this.counter = root.querySelector('[data-zoom-counter]');
      this.closeBtns = root.querySelectorAll('[data-zoom-close]');
      this.currentIndex = 0;

      this.onKeydown = this.onKeydown.bind(this);

      this.bindStaticEvents();
    }

    isElementHidden(el) {
      if (!el) return true;

      // 只判断真正被隐藏的节点，不用 aria-hidden，
      // 因为轮播非当前 slide 也可能带 aria-hidden，但仍然应参与弹窗切换。
      if (el.hidden) return true;
      if (el.closest('[hidden]')) return true;

      const style = window.getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden') return true;

      return false;
    }

    getTriggerContainer(trigger) {
      return (
        trigger.closest('slideshow-slide') ||
        trigger.closest('[ref="media[]"]') ||
        trigger.closest('.product-media-container') ||
        trigger.parentElement
      );
    }

    getItems() {
      const rawItems = Array.from(
        this.gallery.querySelectorAll(
          `[data-custom-zoom-trigger][data-custom-zoom-group="${this.group}"]`
        )
      );

      const visibleItems = rawItems.filter((trigger) => {
        const container = this.getTriggerContainer(trigger);
        return !this.isElementHidden(container);
      });

      // 防止某些主题/轮播实现里出现重复节点
      const deduped = [];
      const seen = new Set();

      for (const item of visibleItems) {
        const key = [
          item.dataset.mediaIndex || '',
          item.dataset.mediaSrc || '',
          item.dataset.mediaAlt || '',
        ].join('::');

        if (seen.has(key)) continue;
        seen.add(key);
        deduped.push(item);
      }

      return deduped.sort((a, b) => {
        return Number(a.dataset.mediaIndex || 0) - Number(b.dataset.mediaIndex || 0);
      });
    }

    bindStaticEvents() {
      this.prevBtn?.addEventListener('click', () => {
        this.show(this.currentIndex - 1);
      });

      this.nextBtn?.addEventListener('click', () => {
        this.show(this.currentIndex + 1);
      });

      this.closeBtns.forEach((btn) => {
        btn.addEventListener('click', () => this.close());
      });
    }

    open(index = 0) {
      const items = this.getItems();
      if (!items.length) return;

      if (index < 0 || index >= items.length) {
        index = 0;
      }

      this.root.classList.add('is-open');
      this.root.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';

      this.show(index);
      document.addEventListener('keydown', this.onKeydown);
    }

    close() {
      this.root.classList.remove('is-open');
      this.root.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this.onKeydown);
    }

    show(index) {
      const items = this.getItems();
      if (!items.length) return;

      if (index < 0) index = items.length - 1;
      if (index >= items.length) index = 0;

      this.currentIndex = index;

      const current = items[index];
      const src = current.dataset.mediaSrc || '';
      const alt = current.dataset.mediaAlt || '';

      if (this.image) {
        this.image.src = src;
        this.image.alt = alt;
      }

      if (this.counter) {
        this.counter.textContent = `${index + 1} / ${items.length}`;
      }

      const single = items.length <= 1;

      if (this.prevBtn) {
        this.prevBtn.hidden = single;
        this.prevBtn.disabled = single;
      }

      if (this.nextBtn) {
        this.nextBtn.hidden = single;
        this.nextBtn.disabled = single;
      }
    }

    onKeydown(event) {
      if (!this.root.classList.contains('is-open')) return;

      if (event.key === 'Escape') this.close();
      if (event.key === 'ArrowLeft') this.show(this.currentIndex - 1);
      if (event.key === 'ArrowRight') this.show(this.currentIndex + 1);
    }
  }

  const INSTANCES = new Map();

  function initCustomZoom() {
    document
      .querySelectorAll('.custom-product-zoom[data-custom-zoom-group]')
      .forEach((root) => {
        const group = root.dataset.customZoomGroup;
        if (!group) return;

        if (INSTANCES.has(group)) {
          INSTANCES.set(group, new CustomProductZoom(root));
        } else {
          INSTANCES.set(group, new CustomProductZoom(root));
        }
      });
  }

  function handleOpen(trigger) {
    const group = trigger.dataset.customZoomGroup;
    const instance = INSTANCES.get(group);
    if (!instance) return;

    const items = instance.getItems();
    const index = items.indexOf(trigger);

    instance.open(index >= 0 ? index : 0);
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(
      '[data-custom-zoom-trigger][data-custom-zoom-group]'
    );
    if (!trigger) return;

    event.preventDefault();
    handleOpen(trigger);
  });

  document.addEventListener('keydown', (event) => {
    const trigger = event.target.closest?.(
      '[data-custom-zoom-trigger][data-custom-zoom-group]'
    );
    if (!trigger) return;

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleOpen(trigger);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomZoom);
  } else {
    initCustomZoom();
  }

  document.addEventListener('shopify:section:load', initCustomZoom);
})();